import * as React from 'react';
import { CircularProgress, CssBaseline, Divider, ThemeProvider } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Grid from '@mui/material/Grid';
import { Link } from "react-router-dom"


import theme from './theme';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from '../store/features/app/appActions';
import { useTranslation } from 'react-i18next';
import { t } from 'i18next';
import ErrorDialog from '../components/ErrorDialog.jsx';
import { setLanguage, setlogginModal } from '../store/features/app/appSlice.js';
import { getSubdomain } from '../utils/utils.js';
import { Navigate, Outlet, useMatch, useNavigate, useLocation, useRouteError, useSearchParams } from "react-router-dom";
import LoginContainer from "../containers/loginContainer/loginContainer.jsx";
import { useAuth } from "react-oidc-context";

export const LoginButton = () => {
    const { isAuthenticated, isLoading, signoutRedirect } = useAuth()
    const { lastURL } = useSelector(state => state.app)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const logout = async () => {
        await signoutRedirect()
        await dispatch(logoutUser())
    }

    const handelClick = () => {
        isAuthenticated ? logout() : navigate("/?returnTo") //Login call
    }

    if (isLoading) return <CircularProgress />

    return <Box sx={{ flexGrow: 0 }}>
        <Button data-testid="appLayout-login-button" onClick={handelClick} variant={isAuthenticated ? "outlined" : "contained"}
            sx={{ my: 1, mx: 1.5, boxShadow: 0 }}>
            {isAuthenticated === true ? t("messages.logOut") : t("messages.login")}
        </Button>
        {isAuthenticated === true && <Button variant="contained" component={Link} to={'/postLogin'}>
            {t("homePage.dashboardLink")}
        </Button>}
    </Box>
}

const AppLayout = () => {
    const navigate = useNavigate()
    const { i18n } = useTranslation()
    const showDBLogo = getSubdomain() == "db"
    const { language } = useSelector(state => state.app)
    const dispatch = useDispatch()

    const handleLanguageChange = (lang) => {
        i18n.changeLanguage(lang)
        dispatch(setLanguage(lang))
        if (location.pathname.includes("usecase")) {
            navigate(`/${lang}/usecase/`);
        }
    }

    const location = useLocation()
   
    return (
        <>
            <LoginContainer />
            <Stack direction={"column"} flex={1} width={"100%"} minHeight={"100vh"}>
                <AppBar position={"static"} color='inherit'
                    sx={{
                        borderBottom: 1,
                        minHeight: 70,
                        borderColor: "#F0F3F5"
                    }}
                    elevation={0}>
                    <Toolbar sx={{ justifyContent: "space-between" }}>
                       
                        {showDBLogo ? <Box
                            component="img"
                            sx={{ width: "60px", height: 50, display: { xs: 'none', md: 'flex' }, p: 1 }}
                            src='/public/images/DB_logo_red_200px_rgb.png'
                        />
                            : 
                            <React.Fragment>
                            <Box onClick={() => navigate("/")} component="img" sx={{ height: 25, ml: 2,cursor:"pointer" }}
                                src="/public/images/x2bim_black.png"></Box>
                                {/* <img className="santa_cap" src="/public/images/santa-cap.png" alt="Santa Cap" /> */}
                                </React.Fragment>}

                        <Box sx={{ flexGrow: 1, ml: 5, display: { xs: 'none', md: 'flex' } }}>

                            {/* <Button component="a" href='dashboard'
                sx={{ my: 2, mx: "2", display: 'block', color: 'inherit' }}
              >
                  {t("homePage.platform")}
              </Button> */}

                        </Box>
                        <Box sx={{ display: { xs: 'none', md: 'flex' }, flexGrow: 0, mr: 5 }}>
                            <Stack direction="row" spacing={2}>
                                {i18n.options.fallbackLng.filter(l => l != "fr").map(lang => {  // TODO: re-enable french once main page is translated
                                    const isActive = language == lang
                                    return (<React.Fragment key={lang}>
                                        <Typography data-testid={`appLayout-language-${lang}`} sx={{
                                            cursor: "pointer",
                                            textTransform: "uppercase",
                                            opacity: isActive ? 1 : .6
                                        }} onClick={() => handleLanguageChange(lang)}>{lang} </Typography>
                                        <Divider orientation="vertical" flexItem></Divider>
                                    </React.Fragment>)
                                })}
                            </Stack>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                            <Box sx={{ display: { xs: 'flex', md: 'none' }, flexGrow: 0, }}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">{t("leftNav.language")}</InputLabel>
                                    <Select
                                        data-testid="appLayout-status-language-select"
                                        size='small'
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={i18n.language}
                                        label="Language"
                                        onChange={(e) => handleLanguageChange(e.target.value)}
                                    >
                                        {i18n.options.fallbackLng.map(lang => {
                                            return <MenuItem data-testid={`appLayout-language-select-${lang}`} key={lang} value={lang}>
                                                {lang}
                                            </MenuItem>
                                        })}


                                    </Select>
                                </FormControl>
                                <Divider sx={{ ml: '16px' }} height='24px' orientation="vertical" flexItem></Divider>
                            </Box>
                            <LoginButton />
                        </Box>
                    </Toolbar>
                </AppBar>

                <Box sx={{
                    flex: 1,
                    overflow: 'auto',
                }}>
                    <Outlet />
                </Box>

                <Stack justifyContent="space-between" alignItems="center" direction="row"
                    flex={0}
                    sx={{ display: 'flex', flexWrap: 'wrap', p: 2, width: "100%", background: "#282d36" }}>

                    <Box component="a" href={`https://infraview.net/${language=="de" ? "de" : "en"}`} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box component="img"
                            alt="InfraView Logo"

                        height={40}
                        src="/public/images/infraView_logo_outline.svg">
                    </Box>
                    </Box>
                    <Box display={"flex"} gap={2} flexWrap="nowrap" justifyContent="center" alignItems="baseline">
                        {/* <Button variant="text" component={Link} to={'/pricing'} sx={{ color: '#fff' }}>
                            {t("messages.pricingButton")}
                        </Button> */}
                        <Button variant="text" component={Link} to={`${language=="de" ? "https://infraview.net/de/unsere-loesungen/planung-bau/x2bim/" : "https://infraview.net/en/our-solutions/design-construction/x2bim/"}`} sx={{ color: '#fff' }} target='_blank'>
                            {t("messages.x2bimToInfraviewButton")}
                        </Button>
                        <Button variant="text" component={Link} to={`${language=="de" ? "https://infraview.net/de/unsere-loesungen/planung-bau/x2bim/x2bim-demoanmeldung/" : "https://infraview.net/en/our-solutions/design-construction/x2bim/x2bim-demo-subscription/"}`} sx={{ color: '#fff' }} target='_blank'>
                            {t("messages.requestADemoButton")}
                        </Button>
                        <Button variant="text" component={Link} to={'https://www.x2bim.com/cms/api/media/file/Allgemeine_Lizenzbedingungen_X2BIM_vx.pdf'} target='_blank' sx={{ color: '#fff' }}>
                            {t("messages.agbsButton")}
                        </Button>
                    </Box>
                  
                    <Stack direction="row" spacing={4}>
                        <Button variant="text" href="https://infraview.net/de/impressum/"
                            sx={{ color: "#fff" }}>{t("homePage.impressum")}</Button>
                        <Button variant="text" href="https://infraview.net/de/datenschutz/"
                            sx={{ color: "#fff" }}>{t("homePage.datenschutz")}</Button>
                    </Stack>
                </Stack>
            </Stack>
        </>)
}

export default AppLayout